import React, { useState } from 'react';
import { Alert, Modal } from 'react-bootstrap';
import { HHIEButton } from '../../../utility/HHIEButton';

export const RemoveModal = (props) => {
    const [show, setShow] = useState(false);
    const [showError, setError] = useState(false);
    const [showSuccess, setSuccess] = useState(false);

    const removeMember = (mid) => {
        const requestOptions = {
            method: 'DELETE'
        };
        fetch('api/registration/RemoveMember/' + mid, requestOptions)
            .then((response) => {
                response.json()
                    .then(text => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        if (text.message.includes("Success")) {
                            //props.removeMember(mid);
                            setSuccess(true)
                        }
                        else {
                            setError(true);
                        }
                    })
                    .catch((error) => {
                        console.log("Remove member Text error: " + error)
                    })
            })
            .catch((error) => {
                console.log("Remove member response " + error)
            });
    }

    const handleClose = () => {
        if (showSuccess) { props.removeMember(props.member.mid); }
        setError(false);
        setSuccess(false);
        setShow(false);
    }
    const fullname = () => {
        var middleName = (props.member.middleName) ? props.member.middleName + " " : "";
        return props.member.firstName + " " + middleName + props.member.lastName;
    }
    return (
        <>
        <HHIEButton 
            variant="danger"
            size="sm"
            disabled={props.member.deactivationRequested || props.member.processing}
            onClick={() => {
                setShow(true);
            }}
            title="Remove"
        />
            {
                <Modal
                    id="member-removed-modal"
                    show={show}
                    size="lg"
                    centered
                    backdrop="static"
                    keyboard={false}
                    onHide={() => { setShow(false); }}
                >
                    {(!showSuccess && !showError) && <Modal.Header>
                        <Modal.Title>Are you sure you want to remove '{fullname()}'?</Modal.Title>
                    </Modal.Header>}
                    <Modal.Body>
                        {(!showSuccess && !showError) && <>This will remove '{fullname()}' from your account entirely, even from the submission queue. </>}
                        {showSuccess && <Alert id="remove-status-alert" variant="success"> {fullname()} has been removed</Alert>}
                        {showError && <Alert id="remove-status-alert" variant="danger">Something went wrong removing {fullname()}.<hr /> <strong>TIP:</strong> </Alert>}
                    </Modal.Body>
                    <Modal.Footer>
                        {(!showSuccess && !showError) 
                            && <HHIEButton className="submit-deactivation-request-by-when"
                                variant="outline-danger" 
                                size="sm"
                                onClick={() => { removeMember(props.member.mid); }}
                                title="Remove"
                                />
                        }
                        <HHIEButton 
                            className="close-button" 
                            variant="primary"
                            size="sm"
                            onClick={() => { handleClose(); }}
                            title="Close"
                        />
                    </Modal.Footer>
                </Modal>
            }
    </>
    );
}
